
import { IrisBase } from '@/models/iris/IrisBase'
import { getDefaultFtpEnable, IFtpEnable } from './IFtpEnable'
import { getDefaultFtpData, IFtpData } from './IFtpData'
import { getDefaultFtp, IFtp } from './IFtp'

export interface IFtpConfig extends IrisBase {
    EnabledMOD:IFtpEnable
    Data:IFtpData
    FTP:IFtp
} 

export const getDefaultFtpConfig = ():IFtpConfig => {
    return {        
        EnabledMOD:getDefaultFtpEnable(),
        Data:getDefaultFtpData(),
        FTP:getDefaultFtp(),
    }
} 